// extracted by mini-css-extract-plugin
export default {"press":"InfoPress_press__ho9fq","grid":"InfoPress_grid__UQcbH","column":"InfoPress_column__l96bF"};